export const defaultCompanyInput = { id: null, trusteeReview: null, submitted: false };

export const defaultSelection = { id: 0, nogaCode: null, label: "loading" };

export const createEmptyCollectionData = () => ({
  companyInputId: null,
  trustee: null,
  nogaCode: null,
  employees: [],
  companyOverheads: [],
  allEmployeeFunctions: [],
});

export function buildDropdownOptionsEmployees(collectionData) {
  return {
    allEmployeeFunctions: collectionData?.allEmployeeFunctions || [],
    specXFunc: collectionData?.employeeFunctions || [],
    employmentLevel: collectionData?.employmentLevels || [],
    employmentStatus: collectionData?.employmentStatuses || [],
    sex: collectionData?.employeeSexes || [],
    employmentType: collectionData?.employmentTypes || [],
  };
}

export const isEmployeeEntryFormDirty = ({ employeeFormDirty, showEmployeeEntryForm }) => Boolean(employeeFormDirty && showEmployeeEntryForm);
